import { ScenarioStatisticShortcut } from '@kurtosys/types/query/scenarioStatistics/ScenarioStatisticShortcut.js';
import {
	IQueryShortcutOptions,
	ShortcutType,
	TRootOptionsShortcutFnReturn,
} from '@kurtosys/types/query/scenarioStatistics/shortcuts/index.js';

import { ScenarioStatisticQuery } from '../../queries/ScenarioStatisticQuery.js';

import { ShortcutBase } from './ShortcutBase.js';

export class PortfolioCompositeFundShortcut extends ShortcutBase {
	constructor(scenarioStatisticQuery: ScenarioStatisticQuery) {
		super(ScenarioStatisticShortcut.portfolioCompositeFund, ShortcutType.rootOptions, scenarioStatisticQuery);
	}
	getRootOptions(shortcutOptions: IQueryShortcutOptions): TRootOptionsShortcutFnReturn {
		const { options = {} } = shortcutOptions;
		const response: TRootOptionsShortcutFnReturn = this.scenarioStatisticQuery.shortcuts.portfolio.getRootOptions({
			...shortcutOptions,
			options: {
				portfolio: {
					key: 'compositeFund',
					options: {
						compositeFund: options.portfolioCompositeFund,
					},
				},
			},
		});
		return response;
	}
}
